import React from "react";

import usePageMeta from "../utils/usePageMeta";
import { SITE_NAME, CONTACT_EMAIL, POLICY_UPDATED } from "../utils/site";

export default function Terms() {
  usePageMeta({
    title: "Terms of service",
    description: `The terms you accept by using ${SITE_NAME}, including account rules, content rules, and the limits of what this site claims.`,
    path: "/terms",
  });

  return (
    <div className="page prose">
      <h1>Terms of service</h1>
      <p className="policy-date">Last updated {POLICY_UPDATED}</p>

      <h2>1. Accepting these terms</h2>
      <p>
        By using {SITE_NAME} you agree to these terms. If you do not agree with
        them, please do not use the site.
      </p>

      <h2>2. Who may use the site</h2>
      <p>
        You must be 18 or older to create an account or to play the California
        Lottery. By creating an account you confirm that you are.
      </p>

      <h2>3. What this site provides</h2>
      <p>
        {SITE_NAME} publishes lottery results and descriptive statistics about
        draws that have already happened. It does not predict future draws, does
        not sell systems or number packages, and makes no claim that anything
        here improves your chances. Any number generator on the site produces
        random output for entertainment. We do not guarantee winnings or any
        financial outcome, because no one honestly can.
      </p>

      <h2>4. Accuracy of results</h2>
      <p>
        Results are drawn from the California Lottery's published feed and may be
        delayed, incomplete, or wrong. Never rely on this site to determine
        whether a ticket has won. The California Lottery's own published results
        are the only authority on that, and you should check any ticket against
        them.
      </p>

      <h2>5. Your account</h2>
      <p>
        You are responsible for keeping your password to yourself and for
        activity under your account. Choose a password you do not use elsewhere.
        Tell us at <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> if you
        believe your account has been used without your permission.
      </p>

      <h2>6. What you post</h2>
      <p>
        You keep ownership of what you write, and grant us permission to display
        it on the site. Anything you post is public. Do not post material that is
        unlawful, abusive, hateful, harassing, deceptive, or that infringes
        someone else's rights; do not post spam or advertising; do not present
        yourself as someone else; and do not claim to be able to predict draws or
        sell a winning method.
      </p>
      <p>
        You can delete your own posts and comments, and the author of a post can
        remove comments left on it. We may remove content or suspend accounts
        that break these rules.
      </p>

      <h2>7. Acceptable use</h2>
      <p>
        Do not attempt to disrupt the site, gain access to accounts or data that
        are not yours, or extract content in bulk by automated means.
      </p>

      <h2>8. Advertising</h2>
      <p>
        The site displays third-party advertising. Advertisements are not
        endorsements, and we are not responsible for advertisers' products or
        conduct.
      </p>

      <h2>9. Liability</h2>
      <p>
        The site is provided as it is, without warranties. To the extent the law
        allows, we are not liable for losses arising from your use of it —
        including gambling losses, decisions made on the basis of anything shown
        here, or interruptions to the service.
      </p>

      <h2>10. Changes</h2>
      <p>
        We may update these terms; the date above will change when we do.
        Continuing to use the site means you accept the revision.
      </p>

      <h2>11. Contact</h2>
      <p>
        Reach us at <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </div>
  );
}
